require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-bruno-reichlin.json") })
        }
      }, "path---interviste-bruno-reichlin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-bruno-reichlin!./.cache/json/interviste-bruno-reichlin.json
// module id = 671
// module chunks = 231608221292675